import { useCallback } from 'react';
import isString from 'lodash/isString';
import { useFilters } from '@atlassian/jira-business-filters';
import {
	useViewPreference,
	ACTIVE_WORKFLOW_PREFERENCE,
} from '@atlassian/jira-business-preferences';
import { useBoardStoreState, useBoardStoreActions } from '../../services/board-store';

/** @deprecated Remove when jwm.board-awesome-enhancements is cleaned up */
export const useActiveWorkflow = () => {
	const { workflows } = useBoardStoreState();
	const { setWorkflowData } = useBoardStoreActions();
	const [activeWorkflowId, setActiveWorkflowId] = useViewPreference(ACTIVE_WORKFLOW_PREFERENCE);
	const { setFilter } = useFilters();

	const setActiveWorkflow = useCallback(
		(newWorkflowId: string) => {
			const workflow = workflows.find((wf) => wf.workflowId === newWorkflowId) ?? workflows[0];
			setActiveWorkflowId(workflow?.workflowId);
			setWorkflowData(workflow);

			// FUN-516: reset filters when switching to a different workflow
			setFilter({});
		},
		[workflows, setActiveWorkflowId, setWorkflowData, setFilter],
	);

	const selectedWorkflowId =
		activeWorkflowId == null || !isString(activeWorkflowId)
			? workflows[0]?.workflowId
			: activeWorkflowId;

	return [selectedWorkflowId, setActiveWorkflow] as const;
};
